import { QUARRY_CODERS } from "@quarryprotocol/quarry-sdk";
import { makeProgramParserHooks } from "@saberhq/sail";

export const {
  mergePool: {
    useSingleData: useMergePoolData,
    useBatchedData: useBatchedMergePools,
    useData: useMergePools,
  },
  mergeMiner: {
    useSingleData: useMergeMinerData,
    useBatchedData: useBatchedMergeMiners,
    useData: useMergeMiners,
  },
} = makeProgramParserHooks(QUARRY_CODERS.MergeMine);

export const {
  miner: {
    useSingleData: useMinerData,
    useBatchedData: useBatchedMiners,
    useData: useMiners,
  },
  quarry: {
    useSingleData: useQuarryData,
    useBatchedData: useBatchedQuarries,
    useData: useQuarries,
  },
  rewarder: {
    useSingleData: useRewarderData,
    useBatchedData: useBatchedRewarders,
    useData: useRewarders,
  },
} = makeProgramParserHooks(QUARRY_CODERS.Mine);

export const {
  mintWrapper: {
    useSingleData: useMintWrapperData,
    useBatchedData: useBatchedMintWrappers,
    useData: useMintWrappers,
  },
  minter: {
    useSingleData: useMinterData,
    useBatchedData: useBatchedMinters,
    useData: useMinters,
  },
} = makeProgramParserHooks(QUARRY_CODERS.MintWrapper);

export const {
  operator: {
    useSingleData: useOperatorData,
    useBatchedData: useBatchedOperators,
    useData: useOperators,
  },
} = makeProgramParserHooks(QUARRY_CODERS.Operator);

export const {
  redeemer: {
    useSingleData: useRedeemerData,
    useBatchedData: useBatchedRedeemers,
    useData: useRedeemers,
  },
} = makeProgramParserHooks(QUARRY_CODERS.Redeemer);

export const {
  registry: {
    useSingleData: useRegistryData,
    useBatchedData: useBatchedRegistries,
    useData: useRegistries,
  },
} = makeProgramParserHooks(QUARRY_CODERS.Registry);
